export function extractProperty<T, K extends keyof T>(
  collection: T[] | null | undefined,
  property: K
): T[K][] {
  if (!collection) return [];
  return collection.map((item) => item[property]);
}
